// utils/jsonApiCursor.js
//
// Shared laravel-json-api cursor-pagination reader. Multiple cursor-paginated
// lists (the Poola offers list in usePoolaOffers, the cross-run Poola claims
// list in usePoolaClaims) accumulate pages the same way, so the "where's the
// next cursor + is there more?" logic lives here as one tested SSOT instead of
// being duplicated per composable.

/**
 * Read a laravel-json-api cursor page's next-cursor + has-more from a
 * deserialized JSON:API document.
 *
 * Prefers `meta.page.{to,hasMore}`; falls back to `links.next` (its presence ⇒
 * more, its `page[after]` query param ⇒ the next cursor) when `meta.page` is
 * absent. Only claims "more" when a cursor was actually extracted — a present-
 * but-unparseable `links.next` (missing/renamed `page[after]`) would otherwise
 * loop re-fetching page 1 forever (every page-1 row dedupes out, hasMore stays
 * true).
 *
 * @param {object} doc - deserialized JSON:API doc ({ data, meta, links }).
 * @returns {{ cursor: string|null, hasMore: boolean }}
 */
export function readPageMeta(doc) {
  const page = doc?.meta?.page ?? {};
  if (page.to != null || page.hasMore != null) {
    return { cursor: page.to ?? null, hasMore: Boolean(page.hasMore) };
  }
  const next = doc?.links?.next;
  if (next) {
    let after = null;
    try {
      after = new URL(next, 'http://_').searchParams.get('page[after]');
    } catch {
      after = null;
    }
    return { cursor: after, hasMore: after != null };
  }
  return { cursor: null, hasMore: false };
}
